"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PresenceGroup: function() {
        return _PresenceGroup.PresenceGroup;
    },
    createMotionComponent: function() {
        return _createMotionComponent.createMotionComponent;
    },
    createPresenceComponent: function() {
        return _createPresenceComponent.createPresenceComponent;
    },
    createPresenceComponentVariant: function() {
        return _createPresenceComponentVariant.createPresenceComponentVariant;
    },
    curves: function() {
        return _motionTokens.curves;
    },
    durations: function() {
        return _motionTokens.durations;
    },
    motionTokens: function() {
        return _motionTokens.motionTokens;
    }
});
const _motionTokens = require("./motions/motionTokens");
const _createMotionComponent = require("./factories/createMotionComponent");
const _createPresenceComponent = require("./factories/createPresenceComponent");
const _createPresenceComponentVariant = require("./factories/createPresenceComponentVariant");
const _PresenceGroup = require("./components/PresenceGroup");
